import { useQuery } from "@tanstack/react-query";
import { http } from "../../../../../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../../../../../consts/api";

export const useDiscounts = (params, options = {}) => {
  return useQuery(
    ["discountReport", params],
    async () => {
      const res = await http.get(HTTP_ENDPOINTS.getDiscounts(), {
        params,
      });
      const composeResponse = {
        clinics: res.data.data.clinics,
        reportData: res.data.data.report_data,
        reportHeader: res.data.data.report_header,
        totalApplied: res.data.data.total_applied,
        totalAmount: res.data.data.total_amount,
      };
      return composeResponse;
    },
    options,
  );
};
